import styled from "styled-components";
import PropTypes from "prop-types";

// DropDownList
// @usage - main navigation login, user profile
export const DropDownList = styled.div`
  display: none;

  ${({ theme }) => theme.mq.lg` 
    background-color: #ffffff;
    border: 0.0625rem solid ${theme.themeColors.borderColor};
    border-radius: 0.75rem;
    box-shadow: ${theme.settings.shadows.boxShadow};
    color: #27272f;
    display: block;
    font-weight: 400;
    justify-content: space-between;
    padding: 1.25rem 1.25rem 0rem 1.25rem;
    position: absolute;
    opacity: ${(props) => (props.hideList && `0`) || `1`};
    right: ${(props) => props.right};
    top: ${(props) => props.top};
    transition-property: visibility, opacity;
    transition-duration:  .25s;
    transition-timing-function: linear;
    visibility: ${(props) => (props.hideList && `hidden`) || `visible`};
    width: 14.6875rem;
    z-index: 5;
  `}
`;

export const MobileDropDownList = styled.div`
  background-color: #ffffff;
  border: 0.0625rem solid ${({ theme }) => theme.themeColors.borderColor};
  border-radius: 0.75rem;
  box-shadow: ${({ theme }) => theme.settings.shadows.boxShadow};
  color: #27272f;
  display: block;
  font-weight: 400;
  justify-content: space-between;
  padding: 0.6rem 1rem;
  position: absolute;
  opacity: ${(props) => (props.hideList && `0`) || `1`};
  right: ${(props) => props.right};
  top: ${(props) => props.top};
  transition-property: visibility, opacity;
  transition-duration: 0.25s;
  transition-timing-function: linear;
  visibility: ${(props) => (props.hideList && `hidden`) || `visible`};
  width: 14.6875rem;
  z-index: 5;
`;

export const DropDownListItem = styled.div`
  display: inline-block;
  margin: 0.3rem 0;
  transform: ${({ theme }) => theme.opacityTransition};
  width: 100%;

  a {
    color: ${({ theme }) => theme.themeColors.darkGreen1};
  }
`;

DropDownList.propTypes = {
  hideList: PropTypes.bool,
  right: PropTypes.string,
  top: PropTypes.string,
};

DropDownList.defaultProps = {
  hideList: true,
  right: "1.875rem",
  top: "5rem",
};
